import React, { useCallback, useContext, useEffect, useState } from 'react'
import { RateAndAccuracyLabel, WrapAccordion } from './Style'
import { useTheme } from 'styles'
import { useSelector } from 'react-redux'
import { isEmpty, keyBy, set } from 'lodash'
import { AccordionSummary } from '@mui/material'
import { prosodies } from 'keys'
import { Chip } from 'components/Form'

const Prosody = () => {
    const { rating } = useSelector(state => state.rating)
    const { assessment } = useSelector(state => state.assessment)

    const { Layout, Gutters } = useTheme()

    const prosodyKeys = keyBy(prosodies, "id")
    const prosody = prosodyKeys[assessment.prosody]

    return (
        <div>
            <React.Fragment>
                <WrapAccordion>
                    <AccordionSummary
                        sx={{
                            ...Layout.fullHeight,
                            pointerEvents: "none"
                        }}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <div style={{ ...Layout.rowHCenter, ...Layout.justifyContentBetween, ...Layout.fullWidth }}>
                            <div style={{ ...Layout.rowHCenter, ...Layout.xlcGap }}>
                                {<RateAndAccuracyLabel>{"פרוזודיה"}</RateAndAccuracyLabel>}
                                {isEmpty(rating) ||
                                    <Chip borderColor={prosody?.borderColor} bg={prosody?.bg}>
                                        {prosody?.name}
                                    </Chip>
                                }
                            </div>
                        </div>
                    </AccordionSummary>
                </WrapAccordion>
            </React.Fragment>
        </div>
    )
}

export default Prosody